var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single-contact" }, [
    _c("div", { staticClass: "single-contact__left" }, [
      _c("div", { staticClass: "single-contact__left-headline" }, [
        _vm._v(_vm._s(_vm.headline))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single-contact__left-subheadline" }, [
        _vm._v(_vm._s(_vm.subheadline))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "single-contact__right" }, [
      _c("div", { staticClass: "single-contact__right-tel" }, [
        _c("a", { attrs: { href: _vm.getTelString() } }, [
          _c("img", {
            attrs: {
              src: "/layout/od_stylebreaker_v1_1/images/phone-receiver.png"
            }
          }),
          _vm._v(_vm._s(_vm.telephone))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single-contact__right-whatsapp" }, [
        _c(
          "a",
          {
            attrs: {
              "data-toggle": "modal",
              "data-target": "#whatsapp_modal",
              href: "#"
            }
          },
          [
            _c("img", {
              attrs: {
                src: "/layout/od_stylebreaker_v1_1/images/whatsappbold.svg"
              }
            }),
            _vm._v(_vm._s(_vm.whatsapp))
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }